export default {
  paymentPlans: [],
  currentPlan: '',
  manualAssessmentCriteria: '',
  currentExtraCondtions: [],
  paymentMethod: null,
}
